import React from 'react';
import { ProjectCard } from './ProjectCard';
import { projects } from '../data/projects';
export function ProjectGrid() {
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2" aria-label="Supported projects in a checkered layout" data-id="element-97" data-mp="1ghr6wiwf4riz">
      {projects.map((project, index) => <ProjectCard key={project.id} title={project.title} description={project.description} imageUrl={project.imageUrl} link={project.link} isExternal={project.isExternal} isWide={index === projects.length - 1} data-id="element-98" data-mp="1q9diigco4sm9" data-mpi={index} />)}
    </div>;
}